export default {
  form: {
    sending: 'Sending request…',
    success: 'Thanks! Our team will get in touch shortly',
    error: 'Sorry! Something went wrong. Try again or contact us at'
  },
  hubspotDisabledAlert:
    "Your deployment doesn't support automated contact requests. Please reach out via Support or directly to your CARTO representative."
}
